module.exports = __webpack_public_path__ + "img/na.8d58ac6b.svg";